import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PieChart, Plus, Trash2 } from "lucide-react";

export default function PollsAdminPage() {
  const [polls, setPolls] = useState([]);
  const [form, setForm] = useState({ question: "", options: ["", ""], news_id: "" });

  const load = () => api.get("/admin/polls").then((r) => setPolls(r.data));
  useEffect(() => { load(); }, []);

  const add = () => setForm({ ...form, options: [...form.options, ""] });
  const setOpt = (i, v) => setForm({ ...form, options: form.options.map((o, idx) => idx === i ? v : o) });
  const rmOpt = (i) => setForm({ ...form, options: form.options.filter((_, idx) => idx !== i) });

  const create = async () => {
    const opts = form.options.filter((o) => o.trim());
    if (!form.question.trim() || opts.length < 2) { toast.error("प्रश्न और कम-से-कम 2 विकल्प चाहिए"); return; }
    try {
      await api.post("/admin/polls", { question: form.question, options: opts, news_id: form.news_id || null });
      toast.success("पोल बना दिया");
      setForm({ question: "", options: ["", ""], news_id: "" });
      load();
    } catch (e) { toast.error(formatError(e)); }
  };
  const del = async (id) => {
    if (!window.confirm("पोल हटा दें?")) return;
    try { await api.delete(`/admin/polls/${id}`); load(); }
    catch (e) { toast.error(formatError(e)); }
  };

  return (
    <div data-testid="admin-polls-page">
      <h1 className="font-devnagri-heading text-3xl font-black text-[#0F172A] flex items-center gap-3 mb-6"><PieChart className="w-6 h-6"/>पोल्स</h1>

      <div className="bg-white border border-slate-200 rounded-lg p-5 mb-6">
        <h3 className="font-bold text-[#0F172A] mb-3">नया पोल बनाएँ</h3>
        <Input placeholder="प्रश्न *" value={form.question} onChange={(e) => setForm({ ...form, question: e.target.value })} className="mb-3" data-testid="poll-q"/>
        <div className="space-y-2 mb-3">
          {form.options.map((o, i) => (
            <div key={`opt-${i}`} className="flex gap-2">
              <Input value={o} onChange={(e) => setOpt(i, e.target.value)} placeholder={`विकल्प ${i + 1}`} data-testid={`poll-opt-${i}`}/>
              {form.options.length > 2 && <Button variant="outline" size="sm" onClick={() => rmOpt(i)}><Trash2 className="w-3.5 h-3.5"/></Button>}
            </div>
          ))}
        </div>
        <div className="flex justify-between">
          <Button variant="outline" size="sm" onClick={add} disabled={form.options.length >= 6}><Plus className="w-3.5 h-3.5 mr-1"/>विकल्प</Button>
          <div className="flex gap-2">
            <Input placeholder="news_id (वैकल्पिक)" value={form.news_id} onChange={(e) => setForm({ ...form, news_id: e.target.value })} className="w-52 h-9"/>
            <Button onClick={create} className="bg-[#0F172A] hover:bg-[#1E3A8A]" data-testid="poll-create">पोल बनाएँ</Button>
          </div>
        </div>
      </div>

      <div className="space-y-3">
        {polls.map((p) => {
          const total = p.total_votes || 0;
          return (
            <div key={p.id} className="bg-white border border-slate-200 rounded-lg p-4" data-testid={`poll-${p.id}`}>
              <div className="flex items-start justify-between gap-2 mb-3">
                <div>
                  <div className="font-bold text-[#0F172A]">{p.question}</div>
                  <div className="text-[10px] text-slate-400 mt-0.5">{total} वोट{p.news_id && ` · news: ${p.news_id}`}</div>
                </div>
                <Button variant="outline" size="sm" onClick={() => del(p.id)} className="text-red-600 border-red-200 hover:bg-red-50"><Trash2 className="w-3.5 h-3.5"/></Button>
              </div>
              <div className="space-y-2">
                {p.options.map((o, i) => {
                  const pct = total ? Math.round(o.votes * 100 / total) : 0;
                  return (
                    <div key={`${p.id}-opt-${i}`}>
                      <div className="flex justify-between text-xs mb-1"><span>{o.text}</span><span className="text-slate-500">{o.votes} · {pct}%</span></div>
                      <div className="h-1.5 rounded-full bg-slate-100 overflow-hidden"><div className="h-full bg-gradient-to-r from-[#EA580C] to-amber-500" style={{ width: `${pct}%` }}/></div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
